export type AuthUser = {
  email: string;
  isAdmin: boolean;
};

async function post(path: string, body?: unknown) {
  const res = await fetch(path, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as { error?: string }).error || 'Request failed');
  return data;
}

export async function login(email: string, password: string): Promise<AuthUser> {
  const data = (await post('/api/auth/login', { email, password })) as { user: AuthUser };
  return data.user;
}

export async function logout(): Promise<void> {
  await post('/api/auth/logout');
}

export async function getMe(): Promise<AuthUser | null> {
  try {
    const res = await fetch('/api/auth/me', { credentials: 'include' });
    if (!res.ok) return null;
    const data = (await res.json()) as { user: AuthUser | null };
    return data.user;
  } catch {
    return null;
  }
}
